import { EconomicsFormData } from '@/types/scenarioEconomics';
import { Alert, Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import ScenarioEconomicsForm from './ScenarioEconomicsForm';

interface ScenarioEconomicsStepProps {
  scenarioId: string;
  onEconomicsChange?: (data: EconomicsFormData) => void;
  initialData?: EconomicsFormData;
  onSaveAndGoToResults?: () => void;
}

const ScenarioEconomicsStep: React.FC<ScenarioEconomicsStepProps> = ({
  scenarioId,
  onEconomicsChange,
  initialData,
  onSaveAndGoToResults,
}) => {
  const [economicsData, setEconomicsData] = useState<EconomicsFormData>(initialData || {});
  const [error, setError] = useState<string | null>(null);

  const handleEconomicsChange = (data: EconomicsFormData) => {
    setEconomicsData(data);
    onEconomicsChange?.(data);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Economic Parameters
      </Typography>

      <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
        Configure economic parameters for your scenario. You can either select a predefined template
        to automatically fill the form, or enter values manually. All fields are editable and can be
        modified after selecting a template.
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <ScenarioEconomicsForm
        scenarioId={scenarioId}
        onEconomicsChange={handleEconomicsChange}
        initialData={initialData}
        onSaveAndGoToResults={onSaveAndGoToResults}
      />
    </Box>
  );
};

export default ScenarioEconomicsStep;


